import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var EditDescComponent = /** @class */ (function () {
    function EditDescComponent(_matDialogRef, data, businessManagerService) {
        this._matDialogRef = _matDialogRef;
        this.businessManagerService = businessManagerService;
        this._MAX_CHARACTERS = 2000;
        this.isBusy = false;
        this.business = data.business;
        this.charRemainingCnt = this.business.description ?
            this._MAX_CHARACTERS - this.business.description.length : this._MAX_CHARACTERS;
        this._originDesc = this.business.description;
    }
    EditDescComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        this.formGroup = new FormGroup({
            description: new FormControl('', [Validators.maxLength(this._MAX_CHARACTERS)])
        });
    };
    EditDescComponent.prototype.cancel = function () {
        this.business.description = this._originDesc;
        this._matDialogRef.close(null);
    };
    EditDescComponent.prototype.textAreaChanged = function () {
        this.charRemainingCnt = this.business.description.length <= this._MAX_CHARACTERS ?
            this._MAX_CHARACTERS - this.business.description.length : 0;
    };
    EditDescComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.business.description) {
                            this.business.description = this.business.description.trim();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.isBusy = true;
                        return [4 /*yield*/, this.businessManagerService.updateBusiness(this.business)];
                    case 2:
                        _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(true);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditDescComponent;
}());
export { EditDescComponent };
